import { QueryClientsArgs } from '../../generated/webapp_gql';

export interface PageInfo {
  startCursor: string;
  endCursor: string;
}

export const BASE_PAGINATION_VARIABLES: QueryClientsArgs = {
  first: undefined,
  last: undefined,
  before: '',
  after: '',
};

export const MAXIMUM_BULK_MESSAGE_COUNT = 20;

export interface QueryParams {
  companiesFilter?: string;
  hasAppInstalled?: string;
  hasRemainingSessions?: string;
  hasUpcomingBooking?: string;
  matchedFilter?: string;
  orderBy?: string;
  pageSize?: string;
  searchFilter?: string;
  who5Filter?: string;
}

export interface MatchParams {
  memberUuid?: string;
}

export const ClientsSearchFieldTestID = 'ClientsSearchField';

export const LOCATION_LOCAL_STORAGE_KEY = 'clients-page-previous-query-params';
